/**
 * Access
 */

import { resolveLifecycleKey } from '@/modules/tickets/utils/ticketLifecycle';

/**
 * Stores
 */

import { useKeycloakStore } from '@/stores/keycloak';
import { useTicketPermissionsStore } from '@/stores/ticketPermissions';

/**
 * Types
 */

import type { TicketPermission } from '@generatedTypes';
import type {
  LifecycleKey,
  TicketLifecycleSource,
} from '@/modules/tickets/utils/ticketLifecycle';

type TicketAccessContext = {
  lifecycleKey: LifecycleKey | undefined;
  isTicketUser: boolean;
  permissions: TicketPermission[] | undefined;
};

/**
 * Builds ticket access context from lifecycle and the permissions store.
 */
function createTicketAccessContext(
  ticket: TicketLifecycleSource,
): TicketAccessContext {
  const lifecycleKey = resolveLifecycleKey(ticket);
  const { isTicketUser } = useKeycloakStore();

  return {
    lifecycleKey,
    isTicketUser,
    permissions: lifecycleKey
      ? useTicketPermissionsStore().permissionsFor(lifecycleKey)
      : undefined,
  };
}

export type { TicketAccessContext };

export { createTicketAccessContext };
